import styled from 'styled-components';

export const PlaylistsWrapper = styled.div`
  aside > div:nth-child(2) {
    height: calc(100% - 60px);
  }
`;
